/**
 * Remote access for the social page reference listing, shared through
 * `useModel('socialPageContext')` and consumed by `pages/v2/Reference/SocialPageList`.
 *
 * Deliberately cache-free, unlike `influencerContext`: this backs a curation
 * screen where the list must reflect what the server currently holds, and where
 * the same record is rarely requested twice.
 *
 * Every call takes `success`/`failed` callbacks instead of returning a value,
 * passes `skipErrorHandler: true` so a failure does not raise a global toast on
 * a screen that renders its own empty/error state, and treats a transport error
 * and a `success: false` body identically.
 *
 * One of four near-identical siblings (home / wiki / social / alias); a change
 * to the shape here almost certainly belongs in the other three too.
 */
// import { useState } from 'react';
import { getV2SocialPagesByInfluencersCount, getV2SocialPages, countV2SocialPages, markSocialPageValidity } from '@/services/rest/api';

export default () => {
  const doGetSocialPagesByInfluencersCount = async (
    success: (socialPages: DATA.SocialPage[]) => void,
    failed: () => void,
  ) => {
    try {
      const msg = await getV2SocialPagesByInfluencersCount({ skipErrorHandler: true });
      if (msg.success && msg.data) {
        success(msg.data);
      } else {
        failed();
      }
    } catch (error) {
      console.error('Error fetching social pages:', error);
      failed();
    }
  };

  const doGetSocialPages = async (
    success: (socialPages: DATA.SocialPage[]) => void,
    failed: () => void,
    isInvalid?: boolean,
    lastId?: string,
  ) => {
    try {
      const msg = await getV2SocialPages(isInvalid, lastId, { skipErrorHandler: true });
      if (msg.success && msg.data) {
        success(msg.data);
      } else {
        failed();
      }
    } catch (error) {
      console.error('Error fetching social pages:', error);
      failed();
    }
  };

  const doCountSocialPages = async (
    success: (count: number) => void,
    failed: () => void,
    isInvalid?: boolean
  ) => {
    try {
      const msg = await countV2SocialPages(isInvalid, { skipErrorHandler: true });
      if (msg.success && typeof(msg.data) === 'number' ) {
        success(msg.data);
      } else {
        failed();
      }
    } catch (error) {
      console.error('Error count social pages:', error);
      failed();
    }
  };

    const doMarkSocialPageValidity = async (
      success: (obj: {id: string, isInvalid: boolean}) => void,
      failed: () => void,
      id: string,
      isInvalid: boolean,
    ) => {
      try {
        const msg = await markSocialPageValidity(id, isInvalid, { skipErrorHandler: true });
        if (msg.success && msg.data) {
          success(msg.data);
        } else {
          failed();
        }
      } catch (error) {
        console.error('Error mark social page validity:', error);
        failed();
      }
    };

  return {
    doGetSocialPagesByInfluencersCount,
    doGetSocialPages,
    doCountSocialPages,
    doMarkSocialPageValidity,
  };
};
